module.exports = __webpack_public_path__ + "img/english.e7dcf1ad.svg";